import { formatPrice2Digits } from '../../Shared/PriceHelper';
import { getProductNetPrice } from './checkoutTrackingHelper';
import ProductHelper = require('../../Shared/ProductHelper');

import ICart = CheckoutflowReponse.ICart;
declare var dataLayer: any[];
declare var __ucCmp: any;

/**
 * führt die dataLayer-Pushes für die Rechnungs- und Lieferadressen aus.
 */

export async function onloadTracking(cart: ICart, ecOrderProcess = '3_RechnungsLieferdaten', step = 3) {
    if (window['__ucCmp'] !== undefined && (await __ucCmp.isInitialized())) {
        let lineItems = cart.lineItems;
        let products = [];
        let productIds = [];
        for (let lineItem of lineItems) {
            let product = lineItem.product;
            productIds.push(product.productId);
            let productPrice = lineItem.singleItemNetPrice
                ? formatPrice2Digits(getProductNetPrice(lineItem), true)
                : '';
            let breadcrumb: string = await ProductHelper.getBreadcrumbByTocId(product.mainTocNodeId);
            products.push({
                name: product.titleMain,
                id: product.productId,
                price: productPrice,
                brand: product.publisher ? product.publisher.publisherName : '',
                category: breadcrumb ? breadcrumb : '',
                variant: product.mediaType ? product.mediaType.mediaTypeName : '',
                quantity: lineItem.quantity,
                dimension8: product.displayFormat,
            });
        }

        dataLayer.push({
            pageTitle: 'Rechnungs-, Liefer-, Zahlungsdaten',
            event: 'eec.checkoutStep',
            ecommerce: {
                checkout: {
                    actionField: { step: step },
                    products: products,
                },
            },
        });

        if ($('#TrackingOrigin').val() === 'regimprozess') {
            registrierungTracking();
        }
    } else {
        setTimeout(onloadTracking.bind(null, cart, ecOrderProcess, step), 100);
    }
}

export function registrierungTracking(): void {
    dataLayer.push({
        event: 'event',
        eventCategory: 'user data',
        eventAction: 'registrierung',
        eventLabel: 'reg im bestellprozess',
        eventValue: '5.0',
    });

    dataLayer.push({
        event: 'econdaEvent',
        ecCustomProperties: {
            Target: ['user data', 'registrierung' + '/' + 'reg im bestellprozess', 5.0, 'd'],
            rqtype: 'hiddenpi',
        },
    });
}
